const name = 'circle-m';

const contents = '<path fill="#FFF" d="M21.679 55h-5.138V26.829h7.126l4.226 9.197 2.983 7.623h.414l2.9-7.623 4.06-9.197h7.209V55h-5.635V42.157l.58-7.043h-.414l-7.291 15.412h-3.895l-7.208-15.412h-.415l.498 7.043z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'M',
};

export default icon;
